import getPWAdminSSOUrl, {
  PWAdminSSOString,
  getPWAdminSSOOptions
} from "@pathwright/auth/src/views/auth/utils/getPWAdminSSOUrl"
import { PWAdminCmdKOption } from "./types"

export function getPWAdminSSOAuthOption(value: string): PWAdminCmdKOption {
  // Click handler that prevents the default navigation if the meta key is pressed.
  // In that case, we prompt the user for a proxy username/email and use that to
  // construct the SSO URL.
  // NOTE: this currently doesn't work in the pw admin command menu, which is probably
  // for the better, but we still allow this behavior on the auth screen.
  const handleLink = (event: React.MouseEvent) => {
    if (event.metaKey) {
      event.preventDefault()
      const proxyUser = prompt("Enter the username/email to proxy into:")
      // If proxyEmail is null, then login action was canceled.
      if (proxyUser !== null) {
        window.location.href = getPWAdminSSOUrl(`admin::${proxyUser || ""}`)
      }
    }
  }

  const targetValue: PWAdminSSOString = `admin::${value || ""}`
  const ssoUrl = getPWAdminSSOUrl(targetValue, { store: false })
  return {
    label: value ? targetValue! : "admin::",
    icon: "avatar",
    href: ssoUrl,
    onClick: handleLink
  }
}

function getPWAdminSSOAuthOptions(): PWAdminCmdKOption[] {
  // Allow pw admin sso in local dev by default.
  const defaultOptions = process.env.NODE_ENV === "development" ? [""] : []
  const options = getPWAdminSSOOptions() || defaultOptions

  return options.map(getPWAdminSSOAuthOption)
}

export default getPWAdminSSOAuthOptions
